module.exports = __webpack_public_path__ + "static/media/f10.70864e93.png";